import React from 'react';
import { Link } from 'react-router-dom';
import { BsCheckCircleFill } from 'react-icons/bs';
import { Container } from 'react-bootstrap';

const OrderSuccess = () => {
    return (
        <Container>
            <div className='order-success-container'>
                <div className='text-center'>
                    <BsCheckCircleFill
                        style={{ height: '60px', width: 'auto' }}
                        className='fillPrimary mb-2'
                    />
                    <h2 className='mt-3 mb-4'>Your order has been placed successfully!</h2>
                    <Link to='/orders' className='primary-btn d-inline-block'>
                        View Orders
                    </Link>
                </div>
            </div>
        </Container>
    );
};

export default OrderSuccess;
